import Component from '@glimmer/component';
import { action } from '@ember/object';

export default class PaperDataTableEditDialog extends Component {
  @action
  outsideClicked() {
    this.args.onClose();
  }
}
